
import TheButton from '@/components/TheButton.vue'
import ThePopup from '@/components/ThePopup.vue'
import profileInfo from '@/mixins/profileInfo'
import authMixin from '@/mixins/authMixin'
import getFromIdMixin from '@/mixins/getFromIdMixin'
// import AnswerCard from "@/components/AnswerCard.vue";
import QuestionCard from "@/components/QuestionCard.vue";
import PaginationButtons from '@/components/PaginationButtons.vue';

export default({
    mixins: [authMixin, getFromIdMixin],
    components: {
        TheButton,
        ThePopup,
        // AnswerCard,
        QuestionCard,
        PaginationButtons
    },
    data() {
        return {
            showPopup: false,
            disableBtn: false,
            bioText: "",
            username: "",
            answersCount: 0,
            pointsCount: 0,
            rank: -1,
            userImg: "",
            currentUserId: "",
            toggleSavedAnswers: false,
            questions : [],
            renderedQuestions: [],
        }
    },
    async mounted(){
        await this.initializeValues();
        this.prepareSavedQuestions();
    },
    methods: {
        syncCurrentList(questions){
            this.renderedQuestions = questions;
        },
        async onFileChanged(e){
            const FR = new FileReader();
            FR.addEventListener("load", async (ev) => {
                await this.editCurrentUser({ picture: ev.target.result })
                this.userImg = ev.target.result;
            }); 
            
            FR.readAsDataURL( e.target.files[0] );

        },
        async prepareSavedQuestions(){            
            const bookmarkedQuestionIds = (await this.getUserFromUniversityId(this.currentUserId.currentUserId)).bookmarkedQuestionIds;
            this.$store.state.questions.forEach(question => {
                if (bookmarkedQuestionIds.includes(question.id)) {
                    this.questions.push(question)
                }
            })
            console.log("currentUser", this.questions);
        },
        async initializeValues(){
            this.currentUserId = await this.getCurrentUser();
            let profile;
            if (String(this.$route.params.user_id) === String(this.currentUserId.currentUserId)) {
                // Profile of current user
                profile =  await this.getUserFromUniversityId(this.currentUserId.currentUserId);
            } else {
                profile =  await this.getUserFromUniversityId(this.$route.params.user_id);
            }
            console.log("sssprofile", profile);
            this.username = profile.name;
            this.userImg = profile.picture;
            this.bioText = profile.bio;
            this.rank = this.getIndexFromUniversityId(profile.universityId);
            this.pointsCount = profile.points;
            this.answersCount = profile.answerIds.length;
        },
        editBio(){
            this.currentBio = this.bioText;
            this.enablePopup();
        },
        async saveChanges(){
            this.getCurrentUser().bio = this.bioText;
            await this.editCurrentUser({ bio: this.bioText })
            this.disablePopup();
        },
        disablePopup(){
            this.showPopup = false;
            this.$refs.profileContainer.classList.remove("blur-sm", "filter")
            this.disableBtn = false;            
        },
        enablePopup(){
            this.showPopup = true;
            this.$refs.profileContainer.classList.add("blur-sm", "filter")
            this.disableBtn = true;
        },
        async discardChanges(){
            this.bioText = (await this.currentUser()).bio;
            this.disablePopup();
        },
    }
})
